import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebaseConfig";
import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebaseConfig";
import { motion } from "framer-motion";

import IdeaMap from "./components/IdeaMap/IdeaMap";
import LandingPage from "./components/LandingPage/LandingPage";
import Layout from "./components/Layout/Layout";
import AuthPage from "./components/AuthPage/AuthPage";
import Account from "./components/Account/Account";
import InfoPage from "./components/More/InfoPage/InfoPage";
import ContactUs from "./components/More/ContactUs/ContactUs";
import PrivacyPolicy from "./components/More/PrivacyPolicy/PrivacyPolicy";
import TermsConditions from "./components/More/TermsConditions/TermsConditions";
import Explore from "./components/Explore/Explore";
import WaitlistPage from "./components/Waitlist/Waitlist";
import DailyWeb from "./components/DailyWeb/DailyWeb";
import LoveCard from "./components/Molly/Molly";
import DailyWebHistory from "./components/DailyWeb/DailyWebHistory/DailyWebHistory";
import ReadOnlyWeb from "./components/DailyWeb/DailyWebHistory/ReadOnlyWeb/ReadOnlyWeb";
import Error404 from "./components/More/Error404/Error404";
import Test from "./components/Test/Test";
import Settings from "./components/Settings/Settings";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // 🚦 track auth init


  useEffect(() => {
  const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
    if (firebaseUser) {
      // fetch extra profile info from Firestore
      const ref = doc(db, "users", firebaseUser.uid);
      const snap = await getDoc(ref);

      if (snap.exists()) {
        setUser({
          ...firebaseUser,
          username: snap.data().username, // ✅ attach Firestore username
        });
      } else {
        setUser(firebaseUser); // fallback
      }
    } else {
      setUser(null);
    }
    setLoading(false);
  });

  return () => unsub();
}, []);



  // ✅ wrapper to protect routes
   const PrivateRoute = ({ children }) => {
    if (loading) {
      return <p>Loading...</p>; // ⏳ or spinner
    }
    return user ? children : <Navigate to="/register" replace />;
  };

  if (loading) {
    // Optional: block whole app until auth is ready
    return (<div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        gap: "1rem",
      }}
    >
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 2, ease: "linear" }}
        style={{
          width: "36px",
          height: "36px",
          borderRadius: "50%",
          background: `
            radial-gradient(circle at 30% 30%, 
              rgba(255,255,255,0.9), 
              rgba(0,112,243,0.8) 40%, 
              rgba(0,0,0,0.25) 100%)`,
        }}
      />
      <p style={{ fontSize: "1rem", color: "#555", fontWeight: 500 }}>
        ... Loading ...
      </p>
    </div>);
  }


  return (
    <Layout user={user}>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/info" element={<InfoPage />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/waitlist" element={<WaitlistPage />} />
        <Route path="/dailyweb" element={<DailyWeb user={user}/>} />
        <Route path="/daily-web-history" element={<DailyWebHistory/>} />
        <Route path="/daily-web-history/:dateId" element={<ReadOnlyWeb />} />
        <Route path="/molly" element={<LoveCard/>} />
        <Route path="/test" element={<Test/>} />

        <Route path="/login" element={<AuthPage user={user} defaultMode="login" />} />
          <Route path="/register" element={<AuthPage defaultMode="register" />} />
        {/* Protected routes */}
        <Route
          path="/ideaMap"
          element={
            <PrivateRoute>
              <IdeaMap user={user} />
            </PrivateRoute>
          }
        />
        <Route
          path="/account"
          element={
            <PrivateRoute>
              <Account user={user} />
            </PrivateRoute>
          }
        />

        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <Settings user={user} />
            </PrivateRoute>
          }
        />

        {/* Catch-all redirect */}
        <Route path="*" element={<Error404 />} />
      </Routes>
    </Layout>
  );
}

export default App;
